import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowUpRight, Target, Award, Users } from "lucide-react";
import { MEDIA } from "@/lib/data";

// Tailwind class mapping per size — used for the bento layout
const SIZE_CLASS = {
  large: "col-span-12 md:col-span-8 aspect-[16/10]",
  medium: "col-span-12 md:col-span-5 aspect-[4/3]",
  small: "col-span-12 md:col-span-4 aspect-[4/5]",
};

export default function QuemSomos() {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    fetch("/galeria.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => Array.isArray(data) && setGallery(data))
      .catch(() => {});
  }, []);

  return (
    <div data-testid="quem-somos-page">
      <section className="relative bg-[#0a0a0a] text-white overflow-hidden">
        <div className="grain absolute inset-0" />
        <div
          className="absolute inset-0 opacity-30"
          style={{ backgroundImage: `url(${MEDIA.warehouse})`, backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-28 md:py-40">
          <div className="overline mb-4">Sobre a Empresa</div>
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl">
            Uma referência<br />
            em <span className="text-[#1FA8E0]">fixação industrial</span>.
          </h1>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-10 md:gap-14">
          <div className="col-span-12 md:col-span-5">
            <div className="overline mb-4">A nossa história</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-5xl text-[#0d4c7d] leading-[0.95] tracking-tight">
              Qualidade, inovação<br />e compromisso.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 space-y-6 text-lg text-[#333] leading-relaxed">
            <p>
              A <strong>CETIBER</strong> é uma empresa especializada na comercialização de sistemas de fixação e acessórios industriais.
            </p>
            <p>
              Fundada com o objetivo de responder às exigências do setor industrial, a empresa tem vindo a consolidar-se
              como uma referência no mercado, baseada na qualidade, inovação e compromisso com o cliente.
            </p>
            <p>
              Com sede na <strong>Maia</strong>, servimos clientes em todo o país, garantindo soluções fiáveis e adaptadas
              às necessidades de cada projeto.
            </p>
            <p>
              Trabalhamos diariamente para oferecer produtos de excelência e um serviço próximo, eficiente e profissional.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#f5f5f5] py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {[
              { i: Target, t: "Missão", d: "Fornecer soluções de fixação fiáveis, que suportem os projetos mais exigentes." },
              { i: Award, t: "Qualidade", d: "Trabalhamos apenas com marcas certificadas e produtos testados pelo setor." },
              { i: Users, t: "Proximidade", d: "Equipa dedicada, atendimento personalizado e resposta rápida em todo o país." },
            ].map(({ i: Icon, t, d }) => (
              <div key={t} className="bg-white p-8 border border-[#e4e4e7] border-t-4 border-t-[#1FA8E0]">
                <Icon size={30} className="text-[#0d4c7d] mb-5" />
                <h3 className="font-display font-bold uppercase text-2xl tracking-wide text-[#222]">{t}</h3>
                <p className="mt-3 text-[#555] leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery — dynamically loaded from /galeria.json */}
      {gallery.length > 0 && (
        <section className="bg-white py-24 md:py-28" data-testid="quem-somos-gallery">
          <div className="max-w-[1400px] mx-auto px-5 md:px-10">
            <div className="overline mb-4">A CETIBER em ação</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-5xl text-[#0d4c7d] leading-[0.95] tracking-tight mb-10">
              Armazém · Showroom · Frota própria
            </h2>
            <div className="grid grid-cols-12 gap-4 md:gap-5">
              {gallery.map((p, i) => (
                <img
                  key={i}
                  src={p.src}
                  alt={p.alt || ""}
                  loading="lazy"
                  className={`object-cover w-full ${SIZE_CLASS[p.size] || SIZE_CLASS.medium}`}
                />
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="bg-[#0d4c7d] text-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="font-display font-bold uppercase text-3xl md:text-4xl">
            Vamos trabalhar juntos.
          </h3>
          <Link to="/contactos" data-testid="quem-somos-cta" className="btn-cet btn-primary">
            Contactar Equipa <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
